import api from '@/services/api'

export default {
    fetchProducts(name = '', brands = [], manufacturers = [], types = []) {
        var baseUrl = `products/?name=${name}`;
        if (brands.length !== 0)
            baseUrl += `&brand=${brands.join(',')}`;
        if (manufacturers.length !== 0)
            baseUrl += `&manufacturer=${manufacturers.join(',')}`;
        if (types.length !== 0)
            baseUrl += `&type=${types.join(',')}`;
        return api.get(baseUrl)
            .then(response => response.data);
    },
    fetchProductTypes() {
        return api.get(`types/`)
            .then(response => response.data);
    },
    fetchProductBrands() {
        return api.get(`brands/`)
            .then(response => response.data);
    },
    fetchProductManufactures() {
        return api.get(`manufacturers/`)
            .then(response => response.data);
    },
    fetchProductPrices(id) {
        return api.get(`prices/${id}`)
            .then(response => response.data);
    },
    fetchProduct(id) {
        return api.get(`product/${id}`)
            .then(response => response.data);
    },
    fetchSpot(latitude=null, longitude=null) {
        var url = 'spot/';
        if (latitude && longitude) {
            url += `?lat=${latitude}&lon=${longitude}`;
        }
        return api.get(url)
            .then(response => response.data);
    }
}